import { render, staticRenderFns } from "./PageConfiguration.vue?vue&type=template&id=9d480076&"
import script from "./PageConfiguration.vue?vue&type=script&lang=js&"
export * from "./PageConfiguration.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports